import { Link } from 'react-router-dom';
import { useState } from 'react';
import { typeLabel, type Film } from '@/mocks/films';
import { isFavorite, toggleFavorite } from '@/utils/favorites';

interface Props {
  film: Film;
  size?: 'sm' | 'md';
}

export default function FilmCard({ film, size = 'md' }: Props) {
  const [fav, setFav] = useState(() => isFavorite(film.id));

  const handleFav = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setFav(toggleFavorite(film.id));
  };

  return (
    <Link
      to={`/detail/${film.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg bg-background-200">
        <div className="relative aspect-[2/3] w-full">
          <img
            src={film.poster}
            alt={`${film.title}海报`}
            title={`${film.title}剧情介绍 - 同学的妈妈`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
          <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-1.5 py-0.5 font-label text-[10px] font-semibold tracking-wide text-background-50">
            {typeLabel[film.type]}
          </span>
          <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-1.5 py-0.5 font-label text-[11px] font-bold text-foreground-950">
            <i className="ri-star-fill text-[10px] w-3 h-3 flex items-center justify-center" />
            {film.rating.toFixed(1)}
          </span>
          <button
            type="button"
            onClick={handleFav}
            aria-label={fav ? '取消收藏' : '收藏'}
            className={`absolute bottom-2 right-2 flex h-8 w-8 items-center justify-center rounded-full transition-all cursor-pointer ${
              fav
                ? 'bg-accent-500 text-foreground-950'
                : 'bg-background-50/90 text-foreground-700 opacity-0 group-hover:opacity-100'
            }`}
          >
            <i className={`${fav ? 'ri-heart-fill' : 'ri-heart-line'} text-sm w-4 h-4 flex items-center justify-center`} />
          </button>
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-foreground-950/80 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
          <p className="pointer-events-none absolute inset-x-2 bottom-2 clamp-3 pr-9 text-[11px] leading-relaxed text-background-50 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            {film.summary}
          </p>
        </div>
      </div>
      <div className="pt-2.5">
        <h3
          className={`truncate font-medium text-foreground-950 transition-colors group-hover:text-accent-600 ${
            size === 'sm' ? 'text-[13px]' : 'text-sm'
          }`}
        >
          {film.title}
        </h3>
        <p className="mt-1 flex items-center gap-1.5 font-label text-[11px] text-foreground-500">
          <span>{film.year}</span>
          <span className="h-2.5 w-px bg-background-300" />
          <span>{film.region}</span>
          <span className="h-2.5 w-px bg-background-300" />
          <span className="truncate">{film.genres[0]}</span>
        </p>
      </div>
    </Link>
  );
}